exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* prevents bg color from leaking outside the border */\n\n/* Override Bootstrap buttons */\n\n.bootstrap-agendor .deal-ranking-modal-overlay .overlay,\n.bootstrap-agendor .deal-ranking-modal-overlay .prompt {\n  z-index: 2010;\n}\n\n.bootstrap-agendor .deal-ranking-modal-overlay .prompt {\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 95%;\n  max-width: 1000px;\n}\n\n.bootstrap-agendor .deal-ranking-modal-scroll {\n  width: 100%;\n  max-height: 62vh;\n  overflow-y: auto;\n}\n\n.bootstrap-agendor .deal-ranking-card-scroll {\n  height: 350px;\n  overflow-y: auto;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/deal-ranking.scss
// module id = 569
// module chunks = 0